import { memo } from 'react';

import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';

interface BreadcrumbLinkWithoutDropdownProps extends BasicComponentProps {
	title?: string;
}

const BreadcrumbLinkWithoutDropdownComponent: React.FC<
	BreadcrumbLinkWithoutDropdownProps
> = ({ title }) => {
	if (!title) return null;

	return (
		<span className='dxnav__breadcrumb-link'>
			<span className='dxnav__breadcrumb-text'>{title}</span>
		</span>
	);
};

const BreadcrumbLinkWithoutDropdown = memo(
	withExposer(
		BreadcrumbLinkWithoutDropdownComponent,
		'breadcrumb_link_without_dropdown',
	),
);

export default BreadcrumbLinkWithoutDropdown;
